import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getAgentTransactions=(id,{startDate,endDate})=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_AGENT_TRANSACTION_START
    })
    await axios.get(`/transactions/filter/agents/${id}/${startDate}/${endDate}`)
                .then(response=>dispatch({
                    type:actionTypes.GET_AGENT_TRANSACTION_SUCCESS,
                    payload:response.data
                }))
                .catch(error=>dispatch({
                    type:actionTypes.GET_AGENT_TRANSACTION_FAIL,
                    payload:getMessage(error)
                }))
}